module.exports = __webpack_public_path__ + "img/thumb_01.362c5f98.jpg";